<div class="pricing-bulk-operations">
  <md-page-section-header [title]="'BULK_OPERATIONS.CHANGE_PRICES' | translate"></md-page-section-header>
  <div class="pricing-bulk-operations-form" [formGroup]="bulkOperationForm">
    <mat-form-field class="date-field no-subscript">
      <mat-label>{{ 'BULK_OPERATIONS.VALID_FROM' | translate }}</mat-label>
      <input matInput formControlName="validFrom" [matDatepicker]="picker" [placeholder]="'BULK_OPERATIONS.SELECT_DATE' | translate" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="type-field no-subscript">
      <mat-label>{{ 'BULK_OPERATIONS.CHANGE_TYPE' | translate }}</mat-label>
      <mat-select formControlName="changeType">
        @for (opt of typeOptions; track $index) {
          <mat-option [value]="opt.value">{{ opt.label | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="factor-field no-subscript">
      <mat-label>{{ 'BULK_OPERATIONS.CHANGE' | translate }}</mat-label>
      <div matTextSuffix class="change-symbol">{{ bulkOperationForm.value.changeType === 'percentage' ? '%' : '€' }}</div>
      <input matInput formControlName="changeFactor" type="number" step="0.1" />
    </mat-form-field>
  </div>
  <div class="pricing-bulk-operations-buttons">
    <div class="selected-indicator">{{ selectedPrices().length }} {{ 'BULK_OPERATIONS.SELECTED' | translate }}</div>
    <button mat-flat-button color="primary" [disabled]="!selectedPrices().length || !bulkOperationForm.valid || isLoading()" (click)="submitChanges()">
      @if (isLoading()) {
        <mat-spinner diameter="20" class="spinner-in-button"></mat-spinner>
      }
      <span>{{ isLoading() ? ('COMMON.STATES.UPDATING' | translate) : ('BULK_OPERATIONS.CHANGE_SELECTED_PRICES' | translate) }}</span>
    </button>
  </div>
</div>
